const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/loop-intelligence/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { loopIntelligenceSearchSchema } from '@/features/loop-intelligence/data/searchState';
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
type LoopIntelligenceBeforeLoadArgs = {
  context: PermissionContext;
  params: {
    loopId: number;
    org: string;
  };
};
export const loopIntelligenceBeforeLoad = async (args: LoopIntelligenceBeforeLoadArgs) => {
  await requirePermission('view_loop')(args);
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/loop-intelligence/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: loopIntelligenceBeforeLoad,
  validateSearch: zodValidator(loopIntelligenceSearchSchema),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loopIntelligence.nav)
    }
  }
});